import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/projectList",
    name: "projectList",
    component: () => import("@/views/projectList/index.vue"),
  },
  {
    path: "/projectIndex",
    name: "projectIndex",
    component: () => import("@/views/homeIndex/index.vue"),
  },
  {
    path: "/applyIndex",
    name: "ApplyIndex",
    component: () => import("@/views/homeIndex/applyIndex.vue"),
  },
  {
    path: "/menhu",
    name: "menhu",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/detailsList",
    name: "detailsList",
    component: () => import("@/views/DetailsList.vue"),
  },
  {
    path: "/detailsItem",
    name: "detailsItem",
    component: () => import("@/views/DetailsItem.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/AboutView.vue"),
  },
  {
    path: "/myApply",
    name: "myApply",
    component: () => import("@/views/MyApply.vue"),
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("@/views/PersonalCenter.vue"),
  },
  {
    path: "/authenhfive",
    name: "authenhfive",
    component: () => import("@/views/AuthenHfive.vue"),
  },
  {
    path: "/auth_result",
    name: "auth_result",
    component: () => import("@/views/AuthResult.vue"),
  },
  {
    path: "/workPost",
    name: "workPost",
    component: () => import("@/views/workPost/index.vue"),
  },
  {
    path: "/workPostDetails",
    name: "workPostDetails",
    component: () => import("@/views/workPost/details.vue"),
  },
  {
    // 人脸识别的H5页面
    path: "/ifram",
    name: "ifram",
    component: () => import("@/views/ifram/index.vue"),
  },
];

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});
import store from "../store";
// import { getUserLogo } from "@/api/pc";
router.beforeEach((to, from, next) => {
  if (isMobile()) {
    window.location.href= process.env.VUE_APP_BASE_URL;
  } else {
    let applyIndex = ["/projectIndex", "/applyIndex"];
    let obj = sessionStorage.logoUrlObj?JSON.parse(sessionStorage.logoUrlObj):{enterpriseLogo:'',memberLogo:''};
    if (applyIndex.indexOf(to.path) > -1) {
      store.dispatch("SET_LOGOIMGURL", obj.memberLogo?obj.memberLogo:require('@/assets/logon.png'));
    }else{
      store.dispatch("SET_LOGOIMGURL", obj.enterpriseLogo?obj.enterpriseLogo:require('@/assets/logon.png'));
    }
    return next();
  }
});

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}
export default router;
